<template>
  <div class="record-search" v-loading="loading" element-loading-text="拼命加载中">
    <div class="headLine">
      <img src="../leftAngle.png" alt="返回上一层" @click="backIndex"/>
      化验设备检定提醒
      <el-button v-if="isHide" type="text" @click="management">管理</el-button>
      <el-button v-else type="text" @click="cancel">取消</el-button>
    </div>
    <div class="search-input">
      <div class="search-btn">
        <button class="btn btn-right" @click.prevent="searchDevice(1)">查询记录</button>
      </div>
    </div>
<!--    @row-click="rowClick"-->
    <div class="search-result warpper" ref="wrapper">
      <el-table
        :data="deviceInfo"
        ref="deviceInfo"
        class="deviceInfo"
        height="100%"
        border
        :row-class-name="tableRowClassName"
        @selection-change="selectionChangeHandle"
        style="width: 100%;"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          header-align="center"
          align="center"
          width="50"
          v-if="!isHide"
        />
        <el-table-column
          prop="name"
          header-align="center"
          align="center"
          label="设备名称"
        />
        <el-table-column
          prop="validity"
          header-align="center"
          align="center"
          label="检定周期(天)"
        />
        <el-table-column
          prop="lastTime"
          header-align="center"
          align="center"
          label="上次检定时间"
        />
        <!--<el-table-column
          prop="lastMaintainTime"
          header-align="center"
          align="center"
          label="上次保养时间"
        />
        <el-table-column
          prop="location"
          header-align="center"
          align="center"
          label="位置"
        />-->
      </el-table>
    </div>

    <div class="bottom-button" v-if="!isHide">
      <div class="button-box">
        <el-button
          type="success"
          @click.prevent="deviceProtect()"
          :disabled="!(deviceInfoSelections.length === 1)"
        >设备检定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popstateLock: 0,//是否监听物理返回键
      loading: false,
      page: 1, // 分页查询，第一次为1
      pullupMsg: '加载更多',
      isShowTips: false,
      isHide: true,  //隐藏复选框
      rowClickStatus: true,  //行点击事件
      devicePositionId: '',
      positionList: [],
      deviceInfo:[],
      deviceInfoSelections: [],
      keyword: null,
    };
  },
  created() {
    this.searchDevice(0);
  },
  watch: {
    popstateLock(val) {
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val) {
        this.addPopstate()
      } else {
        this.removePopstate()
      }
    }
  },
  destroyed() {
    this.removePopstate()
  },
  methods: {
    addPopstate() {
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate() {
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回上一层
    backIndex() {
      this.$router.replace({name: 'hyDevicePage'})
    },
    tableRowClassName({ row }) {
      if (row.isRed) {
        return "danger-row";
      } else {
        return "";
      }
    },
    //管理
    management() {
      this.isHide = false;
      this.rowClickStatus = false;
      this.$refs.wrapper.style.height = "calc(100vh - 50px - 120px)";
      this.$refs.deviceInfo.clearSelection();
    },
    //取消
    cancel(){
      this.isHide = true;
      this.rowClickStatus = true;
      this.$refs.wrapper.style.height = "calc(100vh - 50px - 85px)";
      this.deviceInfoSelections = [];
      this.$refs.deviceInfo.clearSelection();
    },
    //点击某一行
    rowClick(row) {
      if (this.rowClickStatus === true) {
        this.$router.push({name: 'hyverificationcreate', query: {id: row.id}})
      }
    },
    // 多选
    selectionChangeHandle(val) {
      this.deviceInfoSelections = val;
    },
    // 设备鉴定
    deviceProtect() {
      if (this.deviceInfoSelections.length === 1) {
        this.$router.replace({
          name: 'hyverificationcreate',
          query: {
            id: this.deviceInfoSelections[0].id,
            name: this.deviceInfoSelections[0].name,
            permission: true
          }
        });
      } else {
        this.$message.error("只能选择其中一个设备进行检定");
      }
    },
    searchDevice() {
      this.page = 1;
      this.$http.httpGet('/app/laDeviceVerification/list', {
        page: 1,
        limit: 10,
      }).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          if (res.page.list.length == 0) {
            this.$message.info('查无此设备')
          }
          this.deviceInfo = res.page.list
          this.page++
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    _initBScroll() {
      let dom = this.$refs.deviceInfo.bodyWrapper;
      dom.addEventListener("scroll", () => {
        const scrollDistance =dom.scrollHeight - dom.scrollTop - dom.clientHeight -1;
        if (scrollDistance < 0) {
          this.loading = true
          // 发请求加载
          this.$http.httpGet('/app/laDeviceVerification/list', {
            page: this.page,
            limit: 10
          }).then(res => {
            this.loading = false
            if (res.code === 0 && res.msg === 'success') {
              if (res.page.list.length == 0) {
                this.$message.info('没有更多数据了')
                return
              }
              this.page++
              let arr = res.page.list
              this.deviceInfo = this.deviceInfo.concat(arr)
              this.$nextTick(() => {
                  // this.scroll.refresh()
                  // this.scroll.finishPullUp()
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    }
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
    this.$nextTick(() => {
      this._initBScroll()
    })
  }
}
</script>

<style scoped lang="scss">
//@import '@/assets/style/global.scss';
.record-search {
  margin: 0;
  padding: 50px 0 0;
  position: relative;
  width: 100%;
  .headLine {
    height: 50px;
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 9;
    font-size: 16px;
    border-bottom: 1px #efefef solid;

    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }

    button {
      position: absolute;
      right: 0;
      top: 0;
      width: 60px;
      height: 30px;
      line-height: 30px;
      font-weight: 900;
      color: #000000;
    }
  }
  .search-input {
    position: relative;
    margin: 0 0 20px;
    overflow: hidden;
    .search-btn {
      margin-top: 0;
      padding: 20px 20px 0;
      button {
        height: 4rem;
        font-weight: 700;
        display: inline-block;
        width: 40%;
      }
      .btn-right {
        float: right;
        width: 100%;
        background-color: rgb(6, 175, 6);
      }
    }
  }

  .search-result {
    position: relative;
    padding: 0;
    height: calc(100vh - 50px - 85px);
    width: 100%;
    // height: 100%;
    overflow: hidden;

    .result-content {
      padding: 0 20px 10px;
      .result-item {
        position: relative;
        box-sizing: border-box;
        padding: 10px 10px 10px;
        border-radius: 0.5rem;
        margin-top: 1.6rem;
        /*height: 12rem;*/
        background-color: #f2f6fc;
        color: #303133;
        font-size: 1.6rem;
        box-shadow: 0 0.3rem 0.5rem #eee;
        .item-name,
        .item-inventory,
        .item-use{
          position: relative;
          margin-bottom: 5px;
          height: 2rem;
          text-align: left;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;
        }

        .item-btn {
          position: relative;
          margin-bottom: 25px;
          height: 2rem;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;

          button {
            height: 3.2rem;
            font-weight: 700;
            display: inline-block;
            width: 48%;
            background-color: #3A9DF2;
          }
          .btn-left {
              float: left;
          }
          .btn-right {
              float: right;
          }
        }
      }
    }
  }
}

.bottom-button {
  position: fixed;
  left: 0px;
  bottom: 0px;
  text-align: center;
  width: 100%;
  background-color: transparent;
  z-index: 99;
  border-top: 1px #efefef solid;

  .button-box {
    display: flex;
    justify-content: space-around;
    .el-button {
      flex: 1;
      height: 4rem;
      color: #FFFFFF;
      font-size: 1.6rem;
      font-weight: bold;
      border-radius: 0;
      &+.el-button {
        margin: 0;
      }
    }
  }
}

.loading {
  position: fixed;
  bottom: 3rem;
  left: 45%;
  span {
    font-size: 1.4rem;
  }
}

.bottom-tip {
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #333;
  // background: #f2f2f2;
  position: absolute;
  bottom: -5px;
  font-size: 1.6rem;
  left: 0;
}



::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #666;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.el-select-dropdown__item {
  font-size: 14px !important;
  line-height: 34px;
  padding: 0 20px;
}
</style>
